import { useState } from "react";
import { t } from "../utils/i18n";

export default function LoginScreen({ onLogin, lang, onToggleLang }) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    if (!name.trim()) {
      setError(t(lang, "login_name_required"));
      return;
    }
    if (!onLogin(name.trim(), password)) {
      setError(t(lang, "login_error"));
      return;
    }
    setError("");
  };

  return (
    <div className="page">
      <div className="container container--narrow">
        <header className="header">
          <div className="header-top">
            <div className="header-brand">
              <span>🌯</span> Kebatic
            </div>
            <button onClick={onToggleLang} className="lang-button" type="button">
              {lang === "lt" ? "EN" : "LT"}
            </button>
          </div>
          <p className="header-subtitle">{t(lang, "login_subtitle")}</p>
        </header>

        <section className="card login-card">
          <h2 className="section-title">{t(lang, "login_title")}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-field">
              <label className="field-label">{t(lang, "name_label")}</label>
              <input
                type="text"
                value={name}
                autoComplete="username"
                placeholder={t(lang, "name_placeholder")}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="form-field">
              <label className="field-label">{t(lang, "login_password_label")}</label>
              <input
                type="password"
                value={password}
                autoComplete="current-password"
                placeholder={t(lang, "login_password_placeholder")}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            {error && <p className="login-error">{error}</p>}
            <button type="submit">{t(lang, "login_btn")}</button>
          </form>
        </section>
      </div>
    </div>
  );
}
